<template>
  <div class="component-filterView" ref="filterViewEl" v-clickoutside="handleClickOutSide">
    <!-- 筛选菜单 -->
    <ul class="filter-list">
      <li
        :class="`filter-item${selectedId === item.id && item.sort > 0 ? ' active' : ''}`"
        v-for="item in filterList"
        :key="item.id"
        @click="handleClickFilter(item)"
      >
        <span>{{item.name}}</span>
        <img class="sort-icon" v-if="item.hasSelectIcon" :src="selectedIcon" />
        <img class="sort-icon" v-if="item.hasSortIcon" :src="sortIconList[item.sort]" />
      </li>
    </ul>
    <div
      class="select-popup"
      v-if="showSelectPopup"
    >
      <div class="select-popup-mask" :style="{top: `${popupTop}px`}" @click="showSelectPopup=false"></div>
      <!-- 下拉菜单 -->
      <ul class="select-list">
        <li
          v-for="subItem in subList"
          v-show="(channel !== 'jd' && channel !== 'vph') || ((channel === 'jd') && subItem.id !== 1 && subItem.id !== 2) || ((channel === 'vph') && subItem.id !== 1 && subItem.id !== 2 && subItem.id !== 3)"
          :class="`filter-select-item${selectedSubId === subItem.id ? ' active' : ''}`"
          :key="`${selectedId}_${subItem.id}`"
          @click="handleClickSubFilter(subItem)"
        >
          <span>{{subItem.name}}</span>
          <md-icon
            class="icon-selected"
            name="right"
            size="md"
            v-show="selectedSubId === subItem.id"
          ></md-icon>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Popup, PopupTitleBar, Icon } from 'mand-mobile'
import Clickoutside from '@/utils/clickoutside'
const selectSortDefaultIcon = require('../assets/images/sort/select_sort_default.png')
const selectSortUpIcon = require('../assets/images/sort/select_sort_up.png')
const selectSortDownIcon = require('../assets/images/sort/select_sort_down.png')
const sortDefaultIcon = require('../assets/images/sort/sort_default.png')
const sortUpIcon = require('../assets/images/sort/sort_up.png')
const sortDownIcon = require('../assets/images/sort/sort_down.png')
export default {
  name: 'filterView',
  directives: { Clickoutside },
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
  },
  computed: {
    selectedIcon() {
      if (this.selectedSubId === 0) {
        return selectSortDefaultIcon
      } else {
        if (this.showSelectPopup) {
          return selectSortUpIcon
        } else {
          return selectSortDownIcon
        }
      }
    },
  },
  props: {
    channel: {
      type: String,
      default: 'tbk',
    },
  },
  data() {
    return {
      popupTop: 0,
      sortIconList: [sortDefaultIcon, sortUpIcon, sortDownIcon],
      showSelectPopup: false,
      selectedSort: '',
      selectedId: 0,
      selectedSubId: 0,
      subList: [
        { id: 0, name: '综合排序' },
        { id: 1, name: '优惠券面值由高到低' },
        { id: 2, name: '优惠券面值由低到高' },
        { id: 3, name: '推广收益由高到低' },
      ],
      filterList: [
        // sort: 0:默认, 正数:升序 负数:降序
        {
          id: 0,
          name: '综合',
          hasSelectIcon: true,
          hasSortIcon: false,
          sort: 0,
          sortValues: ['', '-3', '3', '-4'],
        },
        {
          id: 1,
          name: '券后价',
          hasSelectIcon: false,
          hasSortIcon: true,
          sort: 0,
          sortValues: ['', '2', '-2'],
        },
        {
          id: 2,
          name: '销量',
          hasSelectIcon: false,
          hasSortIcon: true,
          sort: 0,
          sortValues: ['', '1', '-1'],
        },
      ],
    }
  },
  methods: {
    /**
     * 设置popup位置
     */
    setPopupPosition() {
      const node = this.$refs.filterViewEl
      if (node) {
        this.popupTop = node.offsetTop + node.offsetHeight
      }
    },
    /**
     * 初始化数据
     */
    init() {
      this.filterList[this.selectedId].sort = 0
      this.showSelectPopup = false
      this.selectedSort = ''
      this.selectedId = 0
      this.selectedSubId = 0
    },
    /**
     * 点击filter
     */
    handleClickFilter(item) {
      const lastItem = this.filterList[this.selectedId]
      if (lastItem.id === item.id) {
        // 和上一次相同
        if (item.id === 0) {
          // 综合
          this.showSelectPopup = !this.showSelectPopup // 展开或收回
          this.setPopupPosition()
        } else {
          // 券后价,销量
          lastItem.sort = lastItem.sort === 1 ? 2 : 1
        }
      } else {
        // 和上一次不同
        this.selectedId = item.id
        lastItem.sort = 0
        if (item.id === 0) {
          // 综合
          this.showSelectPopup = true // 展开
          this.setPopupPosition()
        } else {
          // 券后价,销量
          if (lastItem.id === 0) {
            // 上一次是 综合
            this.showSelectPopup = false // 收回
            this.selectedSubId = 0 // 重置下拉列表
          }
          const curItem = this.filterList[this.selectedId]
          curItem.sort = 1
        }
      }
      this.handleChangeSort() // 分发事件
    },
    /**
     * 点击子filter
     */
    handleClickSubFilter(subItem) {
      this.selectedSubId = subItem.id
      this.filterList[0].sort = subItem.id
      this.showSelectPopup = false // 收回
      this.handleChangeSort() // 分发事件
    },
    /**
     * 分发已选择排序事件
     */
    handleChangeSort() {
      const item = this.filterList[this.selectedId]
      const sort = item.sortValues[item.sort]
      if (this.selectedSort !== sort) {
        console.log('更改排序方式:', sort)
        this.selectedSort = sort
        this.$emit('change', sort)
      }
    },
    handleClickOutSide() {
      this.showSelectPopup = false
    },
  },
}
</script>

<style  lang="scss" scoped>
.component-filterView {
  .filter-list {
    position: relative;
    display: flex;
    align-items: center;
    height: 0.72rem;
    line-height: 0.72rem;
    padding: 0 0.3rem;
    background: #fff;
    z-index: 100;
    &:before {
      position: absolute;
      content: ' ';
      top: 0;
      width: 100%;
      height: 1px;
      left: 0;
      border-top: 1px solid #eaeaea;
      color: #eaeaea;
      transform: scaleY(0.5);
    }
    &:after {
      position: absolute;
      content: ' ';
      bottom: 0;
      width: 100%;
      height: 1px;
      left: 0;
      border-bottom: 1px solid #eaeaea;
      color: #eaeaea;
      transform: scaleY(0.5);
    }
    .filter-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.26rem;
      font-weight: 300;
      color: #999;
      cursor: pointer;
      &.active {
        color: #f00;
      }
      .sort-icon {
        height: 0.26rem;
      }
    }
  }
  .select-popup {
    .select-popup-mask {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      pointer-events: auto;
      z-index: 99;
      background-color: rgba(37, 38, 45, 0.7);
    }
    .select-list {
      position: relative;
      z-index: 100;
      background: #fff;
      overflow: auto;
      .filter-select-item {
        padding: 0 0.4rem;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.26rem;
        display: flex;
        align-items: center;
        color: #666;
        &:not(:last-child) {
          border-bottom: 1px solid #eee;
        }
        &.active {
          color: #f00;
        }
        .icon-selected {
          margin-left: auto;
        }
      }
    }
  }
}
</style>